import React from "react";
import Container from "@mui/material/Container";
import theme from "./styles/theme";
import { ThemeProvider } from "@emotion/react";
import Appbar from "./components/appbar";
import { UIProvider } from "./context/ui";
import UserProvider from "./context/user";
import { CssBaseline } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import Services from "../src/components/Pages/Services";
import Home from "./components/Pages/Home";
import About from "../src/components/Pages/About";
import Contact from "../src/components/Pages/Contact";
import Whatsapp from "./components/whatsapp";
import Staff from "./components/Pages/Staff";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="xl">
        <UIProvider>
          <UserProvider>
            <Appbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/Services" element={<Services />} />
              <Route path="/Staff" element={<Staff />} />
              <Route path="/About" element={<About />} />
              <Route path="/Contact" element={<Contact />} />
            </Routes>
          </UserProvider>
        </UIProvider>
        <Whatsapp />
      </Container>
    </ThemeProvider>
  );
}

export default App;
